










import { Component, Prop, Vue } from 'vue-property-decorator';

import BaseScenarioInfo from '@/modules/design/views/BaseScenarioInfo.vue';

import { designStore } from '@/store/store';
import { Route } from 'vue-router';
import { createConcreteValidations } from '@/modules/design/lib/validations/concrete';


@Component({
  components: {
    BaseScenarioInfo,
  },
})
export default class NewConcreteScenarioInfo extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentConcrete;
  }

  get scenarioImperial() {
    return designStore.currentConcreteImperial;
  }

  validations() {
    return createConcreteValidations(this.scenarioImperial);
  }

  sync() {
    designStore.setCurrentConcreteScenario(this.scenario);
  }

  save() {
    this.sync();
    designStore.saveCurrentConcreteScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }
}

